import { isEqual } from 'lodash';

import UserRole from '@careerstart/wae-common/src/main/constants/user-role';

import { ACTION_BLUE, FEED_BACK } from '../../theme/colorConstants';
import { BULK_ACTION_TYPES } from '../../views/timekeeping/timekeepingConstants';
import { getCardFilterPayload } from '../../views/timekeeping/timekeepingHelpers';

const getStepDataV2 = ({
  timecardCounts,
  role,
  startDate,
  endDate,
  handleOnCardClick,
  currentParams,
  globalFilterParams = {},
  workedTimeEpochs,
}) => {
  const cardFilterPayload = getCardFilterPayload(startDate, endDate);
  const isFilteredByGlobalFilters = Object.keys(globalFilterParams).length > 0;
  const step1Params = { ...cardFilterPayload.step1, ...globalFilterParams };
  const step2Params = { ...cardFilterPayload.step2, ...globalFilterParams };
  const step3Params = { ...cardFilterPayload.step3, ...globalFilterParams };
  const step4Params = { ...cardFilterPayload.step4, ...globalFilterParams };

  const approveOrResolveCard = {
    color: FEED_BACK.GREEN_70,
    onCardClick: () => {
      handleOnCardClick({
        filterVal: step1Params,
        actionType:
          role === UserRole.EMPLOYER ? BULK_ACTION_TYPES.APPROVE : BULK_ACTION_TYPES.RESOLVE,
        customCount: timecardCounts?.readyToApproveOrResolve,
        totalTimeEpoch:
          role === UserRole.EMPLOYER
            ? workedTimeEpochs?.corporation?.readyToApproveOrResolveEpoch
            : workedTimeEpochs?.readyToApproveOrResolveEpoch,
      });
    },
    header: 'timekeeping.counterCards.step3',
    subHeader:
      role === UserRole.EMPLOYER
        ? 'timekeeping.counterCardsV2.step3.subHeaderApprove'
        : 'timekeeping.counterCardsV2.step3.subHeaderResolve',
    body: 'timekeeping.counterCards.step1.body',
    buttonText:
      role === UserRole.EMPLOYER
        ? 'timekeeping.counterCards.selectButtonTextApprove'
        : 'timekeeping.counterCards.selectButtonTextResolve',
    hideButton: role === UserRole.RECRUITER,
    count: timecardCounts?.readyToApproveOrResolve,
    isCompleted: timecardCounts?.readyToApproveOrResolve === 0,
    isSelected: isEqual(currentParams, step1Params),
    isFiltered: isFilteredByGlobalFilters,
  };

  const needsAttentionCard = {
    color: ACTION_BLUE.INDIGO_BLUE_REST,
    onCardClick: () => handleOnCardClick({ filterVal: step2Params }),
    header: 'timekeeping.counterCards.step2',
    subHeader: 'timekeeping.counterCardsV2.step2.subHeader',
    body: 'timekeeping.counterCards.step2.body',
    buttonText: 'timekeeping.counterCards.viewButtonText',
    count: timecardCounts?.suspiciousOrMissingPunches,
    isCompleted: timecardCounts?.suspiciousOrMissingPunches === 0,
    isSelected: isEqual(currentParams, step2Params),
    isFiltered: isFilteredByGlobalFilters,
  };

  const resolveDisputesCard = {
    color: FEED_BACK.ORANGE_20,
    onCardClick: () => handleOnCardClick({ filterVal: step3Params }),
    header: 'timekeeping.counterCards.step1',
    subHeader: 'timekeeping.counterCardsV2.step1.subHeader',
    body: 'timekeeping.counterCards.step3.body',
    buttonText: 'timekeeping.counterCards.viewButtonText',
    count: timecardCounts?.disputed,
    isCompleted: timecardCounts?.disputed === 0,
    isSelected: isEqual(currentParams, step3Params),
    isFiltered: isFilteredByGlobalFilters,
  };

  const finalizeCard =
    role === UserRole.RECRUITER || role === UserRole.ADMIN
      ? {
          color: FEED_BACK.ORANGE_20,
          onCardClick: () =>
            handleOnCardClick({
              filterVal: step4Params,
              actionType: BULK_ACTION_TYPES.FINALIZE,
            }),
          header: 'timekeeping.counterCards.step4',
          subHeader: 'timekeeping.counterCardsV2.step4.subHeader',
          body: 'timekeeping.counterCards.step4.body',
          buttonText: 'timekeeping.counterCards.selectButtonTextFinalize',
          count: timecardCounts?.readyToFinalize,
          isCompleted: timecardCounts?.readyToFinalize === 0,
          isSelected: isEqual(currentParams, step4Params),
          isFiltered: isFilteredByGlobalFilters,
        }
      : null;

  return [
    resolveDisputesCard,
    needsAttentionCard,
    approveOrResolveCard,
    ...(finalizeCard ? [finalizeCard] : []),
  ];
};

export default getStepDataV2;
